import { FormulaTree } from "utils/services";
import ReactDOM from "react-dom";
import { v4 } from "uuid";
import { isNumeric } from "utils/helpers";

const SelectFormulaDropdown = ({
  onSelectItem,
  searchValue,
  currentInputPosition,
  dropdownData,
  isFullWidth = false,
  closeDropdown,
}) => {
  const onSelectHandler = (item) => () => {
    onSelectItem(item);
    closeDropdown?.();
  };

  const isValidNumber = isNumeric(searchValue);

  const style = currentInputPosition
    ? {
        top: currentInputPosition.top + currentInputPosition.height,
        left: currentInputPosition.left,
        width: isFullWidth ? currentInputPosition.width : null,
        maxWidth: isFullWidth ? 'unset' : null,
      }
    : {};

  const renderItems = (values) => {
    return (
      <>
        {values.map((item) => {
            return (
              <div
                key={item.id}
                onClick={onSelectHandler(item)}
                className="select-formula-dropdown-dropdown-item"
              >
                {item.name}
              </div>
            );
          })}
      </>
    );
  };

  const dropdownJSX = () => {
    return (
      <div className="select-formula-dropdown-dropdown" style={style}>
        {isValidNumber ? (
          <>
            <div
              onClick={onSelectHandler({
                key: v4(),
                name: searchValue,
                label: `${searchValue}`,
                valueType: "number",
                nextNodeType: [FormulaTree.NODE_TYPES.Operator],
                type: FormulaTree.NODE_TYPES.Value,
              })}
              className="select-formula-dropdown-dropdown-item"
            >
              {searchValue}
              <span className="hint-text">- Insert like number</span>
            </div>
          </>
        ) : null}
        {Object.entries(dropdownData).map(([title, values], index) => {

          const filteredValues = values.filter((item) => {
            return searchValue
              ? item.name.toLowerCase().includes(searchValue.toLowerCase())
              : true;
          })

          if (filteredValues?.length < 1) {
            return null
          }

          return (
            <>
              <div
                key={index}
                className="select-formula-dropdown-title"
              >
                {title}
              </div>
              {
                renderItems(filteredValues)
              }
              <div className="select-formula-dropdown-border"></div>
            </>
          );
        })}
      </div>
    );
  };

  return ReactDOM.createPortal(
    dropdownJSX(),
    document.querySelector("#dropdowns")
  );
};

export default SelectFormulaDropdown;
